import styled from "styled-components";

import { BreadcrumbStyledProps as Props } from "./Breadcrumb.types";
import { CONSTANTS } from "config/constants";

const { tablet } = CONSTANTS.BREAKPOINTS;

const BreadcrumbStyled = styled.div<Props>`
  display: flex;
  padding: 1.6rem 0;
  border-bottom: 0.1rem solid var(--palette-grey-blue-s15-l80);
  border-top: 0.1rem solid var(--palette-grey-blue-s15-l80);
  padding-left: 7.2rem;

  @media (max-width: ${tablet}px) {
    justify-content: center;
    padding-left: 0;
  }

  .Breadcrumb {
    &__item {
      font-weight: 600;
      color: var(--palette-black-s0-l10);
      font-size: 1.4rem;
    }

    &__icon {
      display: flex;
    }

    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      & > *:not(:first-child) {
        padding: 0 0.8rem;
      }

      & > *:first-child {
        padding-right: 0.8rem;
      }
    }
  }
`;

export default BreadcrumbStyled;
